<template>
  <div v-if="adminInfo">
    <h6>🗝 网站管理信息</h6>
    <div>
      <div @click="goToAdminPage" class="admin-click">
        <el-avatar
          shape="square"
          :size="99"
          :src="adminInfo.logo_url"
          fit="fill"
        >
        </el-avatar>
        <div>
          {{ adminInfo.business_name }}
        </div>
      </div>
      <div class="admin-social-media">
        <span v-if="adminInfo.facebook">
          <a :href="adminInfo.facebook">
            <font-awesome-icon :icon="['fab', 'facebook']" /> &nbsp;
          </a>
        </span>
        <span v-if="adminInfo.twitter">
          <a :href="adminInfo.twitter">
            <font-awesome-icon :icon="['fab', 'twitter']" /> &nbsp;
          </a>
        </span>
        <span v-if="adminInfo.youtube">
          <a :href="adminInfo.youtube">
            <font-awesome-icon :icon="['fab', 'youtube']" /> &nbsp;
          </a>
        </span>
        <span v-if="adminInfo.instagram">
          <a :href="adminInfo.instagram">
            <font-awesome-icon :icon="['fab', 'instagram']" />
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      adminInfo: ""
    };
  },
  mounted: function() {
    this.getAdminInfo();
  },
  methods: {
    getAdminInfo: function() {
      this.$axios.get("/cities/admin").then(response => {
        this.adminInfo = response.data;
      });
    },
    goToAdminPage: function() {
      window.open("/admin");
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style>
.admin-social-media {
  font-size: 18px !important;
}

.admin-click {
  cursor: pointer;
}
</style>
